var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * CompsApiList 通用API接口列表面板组件
 * 用于显示接口列表，支持分类分组和选择
 * 支持一级分类（可折叠）和二级分类
 */
import React, { useState } from "react";
import { List, Typography, Tag, Space, Card, Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";
var Text = Typography.Text;
var Panel = Collapse.Panel;
// 方法颜色映射
var METHOD_COLORS = {
    GET: "blue",
    POST: "green",
    PUT: "orange",
    DELETE: "red",
    PATCH: "purple",
};
var CompsApiList = function (_a) {
    var _b = _a.title, title = _b === void 0 ? "接口列表" : _b, groups = _a.groups, categoryGroups = _a.categoryGroups, selectedId = _a.selectedId, onSelect = _a.onSelect, _c = _a.width, width = _c === void 0 ? "400px" : _c, _d = _a.height, height = _d === void 0 ? "100%" : _d;
    // 展开的一级分类key（用于控制折叠状态）
    var _e = useState(function () {
        // 默认展开所有一级分类
        if (categoryGroups) {
            return categoryGroups.map(function (_, index) { return "category-".concat(index); });
        }
        return [];
    }), expandedKeys = _e[0], setExpandedKeys = _e[1];
    // 渲染接口列表项
    var renderApiListItem = function (api) { return (_jsx(List.Item, __assign({ onClick: function () { return onSelect(api.id); }, style: {
            cursor: "pointer",
            backgroundColor: selectedId === api.id ? "#e6f7ff" : "transparent",
            borderLeft: selectedId === api.id ? "3px solid #1890ff" : "3px solid transparent",
            padding: "12px 16px",
            transition: "all 0.3s",
        }, onMouseEnter: function (e) {
            if (selectedId !== api.id) {
                e.currentTarget.style.backgroundColor = "#f5f5f5";
            }
        }, onMouseLeave: function (e) {
            if (selectedId !== api.id) {
                e.currentTarget.style.backgroundColor = "transparent";
            }
        } }, { children: _jsxs(Space, __assign({ direction: "vertical", size: 4, style: { width: "100%" } }, { children: [_jsxs(Space, { children: [_jsx(Tag, __assign({ color: METHOD_COLORS[api.method] }, { children: api.method })), _jsx(Text, __assign({ strong: true, style: { fontSize: "14px" } }, { children: api.name }))] }), _jsx(Text, __assign({ type: "secondary", style: { fontSize: "12px" } }, { children: api.path }))] })) }))); };
    // 渲染二级分类组（原来的方式）
    var renderGroup = function (_a, key) {
        var category = _a.category, apis = _a.apis;
        return (_jsxs("div", { children: [_jsx("div", __assign({ style: {
                        padding: "8px 16px",
                        backgroundColor: "#fafafa",
                        borderBottom: "1px solid #f0f0f0",
                        fontWeight: 600,
                        fontSize: "14px",
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                    } }, { children: category })), _jsx(List, { size: "small", dataSource: apis, renderItem: renderApiListItem, split: false })] }, key));
    };
    // 渲染一级分类（可折叠）
    var renderCategoryGroup = function (categoryGroup, index) {
        var panelKey = "category-".concat(index);
        return (_jsx(Panel, __assign({ header: _jsx("span", __assign({ style: { fontWeight: 600, fontSize: "15px" } }, { children: categoryGroup.category })) }, { children: categoryGroup.groups.map(function (group, groupIndex) {
                return renderGroup(group, "".concat(panelKey, "-").concat(groupIndex));
            }) }), panelKey));
    };
    // 判断使用哪种显示方式
    var useCategoryGroups = categoryGroups && categoryGroups.length > 0;
    var useGroups = groups && groups.length > 0;
    return (_jsx(Card, __assign({ title: title, style: {
            width: width,
            height: height,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
        }, bodyStyle: { flex: 1, overflow: "auto", padding: 0 } }, { children: _jsx("div", __assign({ style: { height: "100%", overflow: "auto" } }, { children: useCategoryGroups ? (
            // 使用一级分类（可折叠）方式
            _jsx(Collapse, __assign({ activeKey: expandedKeys, onChange: function (keys) { return setExpandedKeys(keys); }, ghost: true, expandIcon: function (_a) {
                    var isActive = _a.isActive;
                    return (_jsx(DownOutlined, { rotate: isActive ? 180 : 0, style: { fontSize: "12px" } }));
                }, style: { backgroundColor: "transparent" } }, { children: categoryGroups.map(function (categoryGroup, index) {
                    return renderCategoryGroup(categoryGroup, index);
                }) }))) : useGroups ? (
            // 使用原来的方式（向后兼容）
            groups.map(function (group, index) { return renderGroup(group, index); })) : null })) })));
};
export default CompsApiList;
